import React from "react";
import { Container } from "react-bootstrap";
import { useParams } from "react-router-dom";
import PdfViewerCard from "../../PdfViewerCard";
import documentos from "./documentosProcesosInternos";
import "../../incidentes.css";

const DocumentoProcesoInterno = () => {
  const { slug } = useParams();
  const documento = documentos.find((d) => d.slug === slug);

  if (!documento) {
    return (
      <Container fluid className="background-containerr">
        <div className="orgproc-header">
          <h1 className="orgproc-heading">Documento no encontrado</h1>
        </div>
      </Container>
    );
  }

  const pdfUrl = `${process.env.REACT_APP_BUCKET}/pdf/${documento.pdf}`;

  return (
    <Container fluid className="background-containerr">
      <div className="orgproc-header">
        <h1 className="orgproc-heading">{documento.titulo}</h1>
      </div>
      <PdfViewerCard pdfUrl={pdfUrl} titulo={documento.titulo} />
    </Container>
  );
};

export default DocumentoProcesoInterno;
